import Menu from "./Menu";
import axios from "axios";

export default class MenusApi {

    BASE_URL = process.env.NODE_ENV === 'production' ? window.location.protocol + "//" + window.location.host + window.location.pathname.split('/').slice(0,window.location.pathname.split('/').length-1).join('/') : 'http://wewp-plugins/wp-admin';

    fetch = async (): Promise<Menu[]> => {
        const {data} = await axios.post(`${this.BASE_URL}/admin-ajax.php`, `action=wpex_get_menu_items`, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });

        return data;
    }
}
